import * as React from 'react';
import SchoolIcon from '@material-ui/icons/School';
import { AnchorListItem } from '@pec/aion-ui-components/components/Nav/AnchorListItem';
import { WorkerBadgeIcon } from '@pec/aion-ui-components/components/Nav/WorkerBadgeIcon';
import { useTranslation } from 'react-i18next';
import { Feature } from 'flagged';
import { FeatureFlagWrapper } from '@pec/aion-ui-core/features/featureFlags/components/FeatureFlagWrapper';
import { PECEnv } from '@pec/aion-ui-core/interfaces/serverTokens';
import { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { InlineBadge } from '@pec/aion-ui-components/components/InlineBadge';
import { CommonRootState } from '@pec/aion-ui-core/combineReducers';
import { fetchPendingCoursesAndProgramsCount } from '@pec/aion-ui-core/actions/fetchPendingCoursesAndProgramsCount';
import { usePermission } from '../hooks/usePermission';

type Props = {
  navExpanded: boolean;
};

export const SideNav: React.FC<Props> = ({ navExpanded }) => {
  const { t } = useTranslation();
  const { serverTokens } = useSelector((state: CommonRootState) => state.serverTokens);
  const { userInfo } = useSelector((state: CommonRootState) => state.userInfo);
  const { pendingCoursesAndProgramsCount } = useSelector((state: CommonRootState) => state.notifications);
  const dispatch = useDispatch();
  const [doceboUrl, setDoceboUrl] = useState('');
  const [gwpUrl, setGwpUrl] = useState('');
  const { featureFlags } = useSelector((state: CommonRootState) => state.featureFlags);
  const { shouldShowWPLink } = usePermission();

  useEffect(() => {
    const { beta, dev, production } = PECEnv;

    const doceboUrlMap = {
      [dev]: 'https://veriforce-lmssandbox.docebosaas.com/learn/mycourses?mclp0=s-_"not_started"_"in_progress"',
      [beta]: 'https://veriforcesandbox.docebosaas.com/learn/mycourses?mclp0=s-_"not_started"_"in_progress"',
      [production]: 'https://veriforce-lms.docebosaas.com/learn/mycourses?mclp0=s-_"not_started"_"in_progress"'
    };
    if (serverTokens) {
      setDoceboUrl(doceboUrlMap[serverTokens.pecEnv] || doceboUrlMap[dev]);
    }
  }, [serverTokens]);

  useEffect(() => {
    const { beta, dev, production } = PECEnv;

    const gwpUrlMap = {
      [dev]: 'https://wp.qa-veriforceone.com/gwp/com.vfwp.site.loginveriforceone',
      [beta]: 'https://wp.beta-veriforceone.com/gwp/com.vfwp.site.loginveriforceone',
      [production]: 'https://wp.veriforceone.com/gwp/com.vfwp.site.loginveriforceone'
    };
    if (serverTokens) {
      setGwpUrl(gwpUrlMap[serverTokens.pecEnv] || gwpUrlMap[dev]);
    }
  }, [serverTokens]);

  useEffect(() => {
    if (featureFlags?.length) {
      let feature = featureFlags.find(x => x.Key === 'FeatureManagement:AionAccessLMSLinkSelfRegisteredUI');
      let isEnabled = atob(feature?.Value || '');
      if (userInfo?.userId && isEnabled === 'true') {
        dispatch(fetchPendingCoursesAndProgramsCount(userInfo.userId));
      }
    }
  }, [dispatch, userInfo, featureFlags]);

  return (
    <>
      <AnchorListItem divider tooltip={!navExpanded} icon={<SchoolIcon />} href="/eLearning">
        {t('user:sideNav.eLearning', 'eLearning')}
      </AnchorListItem>
      <FeatureFlagWrapper>
        <Feature name="AionAccessLMSLinkSelfRegisteredUI">
          <AnchorListItem divider tooltip={!navExpanded} icon={<SchoolIcon />} target="_blank" inset href={doceboUrl}>
            <InlineBadge badgeContent={pendingCoursesAndProgramsCount}>
              {t('user:sideNav.veriforceLearn', 'Veriforce Learn')}
            </InlineBadge>
          </AnchorListItem>
        </Feature>
      </FeatureFlagWrapper>
      {shouldShowWPLink && (
        <AnchorListItem divider tooltip={!navExpanded} icon={<WorkerBadgeIcon />} href={gwpUrl}>
          {t('user:sideNav.workerPass', 'WorkerPass')}
        </AnchorListItem>
      )}
    </>
  );
};
